// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__Eu3zK","sm":"Divider_sm__ZBaII","lg":"Divider_lg__nQScd"};